import { CallApi, handleJSONResponse } from './common';
import { AnalyticsQueryTypes } from '@services/analytics/types/analytics-query-enum';

const callAPI = CallApi('analytics');

export const query = async ({
  artistId,
  start,
  end,
  dsps,
  range,
  queryDataType,
}: {
  artistId: string;
  start?: number;
  end?: number;
  dsps?: string[];
  range: string;
  queryDataType: AnalyticsQueryTypes;
}) => {
  const queryParams = new URLSearchParams();

  if (range) {
    queryParams.append('range', `${range}`);
  }
  if (start) {
    queryParams.append('start', `${start}`);
  }
  if (end) {
    queryParams.append('end', `${end}`);
  }
  if (dsps && dsps.length) {
    queryParams.append('dsps', dsps.join(','));
  }

  const response = await callAPI(
    `/${artistId}/${queryDataType}?${queryParams}`,
    'GET'
  );

  return await handleJSONResponse(response);
};
